import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton,
  Box 
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

interface HeaderBarProps {
  title: string;
  showBackButton?: boolean;
  onBack?: () => void;
  rightButton?: React.ReactNode;
}

export const HeaderBar: React.FC<HeaderBarProps> = ({ 
  title, 
  showBackButton = false, 
  onBack,
  rightButton
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };
 
  return (
    <AppBar 
      position="fixed" 
      elevation={0}
      sx={{ 
        bgcolor: '#1f2937', // Exact theme background.paper color
        color: '#f9fafb', // Exact theme text.primary color
        boxShadow: 'none',
        borderBottom: '1px solid #374151', // Add subtle border for definition
        zIndex: 1300,
        top: 0,
        left: 0,
        right: 0,
        // iOS PWA safe area support
        paddingTop: 'env(safe-area-inset-top, 0px)',
        // Ensure proper positioning on iOS and prevent disappearing
        WebkitTransform: 'translateZ(0)',
        transform: 'translateZ(0)',
        willChange: 'auto',
        backfaceVisibility: 'visible',
        WebkitBackfaceVisibility: 'visible',
        // Force the header to stay in the viewport
        position: 'fixed !important',
      }}
    >
      <Toolbar sx={{ 
        minHeight: 56,
        px: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {/* Left side - Back button or spacer */}
        <Box sx={{ width: 48, height: 48, display: 'flex', alignItems: 'center' }}>
          {showBackButton && (
            <IconButton
              onClick={handleBack}
              size="medium"
              sx={{ 
                color: 'text.primary',
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              <ArrowBack />
            </IconButton>
          )}
        </Box>

        {/* Center - Title */}
        <Typography 
          variant="h6" 
          component="h1" 
          sx={{ 
            fontWeight: 600,
            fontSize: '1.1rem',
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            mx: 1,
          }}
        >
          {title}
        </Typography>

        {/* Right side - Optional button or spacer */}
        <Box sx={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {rightButton}
        </Box>
      </Toolbar>
    </AppBar>
  );
}; 